<script>
import { onMount } from 'svelte';
import {Label, Icon} from '@smui/common';
import IconButton from '@smui/icon-button';
import Tooltip, { Content, Wrapper, Link, RichActions } from '@smui/tooltip';

// import { providers } from '../common'
import { dataProviderSettings, DATA_START_MONTH, DATA_END_MONTH } from '../../settings'
console.log("dataProviderSettings", dataProviderSettings)

const mapRefs = {};
let markers = []
let lines = []
let mapFullscreen = -1;

export let title = "..."
export let mdIcon = "directions_bike"
export let subtitle = "List of most popular stations to start cycle trips for 2019 & 2020 by city"
export let popupInfo = {}
export let stationLocations = {} // station stationLocations
export let popularStations = {} // list of popular popularStations
export let providersUnderscore = ['bluebike_boston', 'citibike_nyc', 'divvy_chicago', 'bikeshare_la']
export let providersDash = { 'bluebike-boston': {}, 'citibike-nyc': {}, 'divvy-chicago': {}, 'bikeshare-la': {} }

let providerDetails = Object.keys(providersDash).map(x => dataProviderSettings.find(y => y.id === x))
Object.keys(providersDash).forEach(x => providersDash[x] = dataProviderSettings.find(y => y.id === x))

const goFullscreen = (i) => {
  mapFullscreen = i
  setTimeout(() => {
    mapRefs['map-2019-' + i].invalidateSize();
    mapRefs['map-2020-' + i].invalidateSize();
  }, 500)
  // const map = document.getElementById('map-2019-' + i)
  // console.log("goFullscreen -> map", map)
  // if (!map) {
  //   return
  // }
  // const mapsEl = map.parentElement.parentElement
  // console.log("goFullscreen -> mapsEl", mapsEl)
  // mapsEl.classList.add('map-fullscreen');
}
const closeFullscreen = (i) => {
  mapFullscreen = -1
}
onMount(async () => {
  providersUnderscore.forEach((providerIdUnderscore, iIndex) => {
    let maxCount = Math.max(...popularStations[providerIdUnderscore].results.map(x => x.station_count))
    const providerIdDash = providerIdUnderscore.split("_").join("-")
    let providerMatch = dataProviderSettings.find(x => x.id === providerIdDash)
    let years = [{ yr: 2019, color: '#18c7de' }, { yr: 2020, color: '#e5ff00' }]
    years.forEach(year => {
      let map = L.map('map-' + year.yr + '-' + iIndex, {
        minZoom: 7,
        maxZoom: 17,
        scrollWheelZoom: false
      }).setView(providerMatch.location, 12);
      L.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}', {
          attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
          maxZoom: 18,
          id: 'steerdigital/ckm6emqze5cd217qxqevdk78i',
          tileSize: 512,
          zoomOffset: -1,
          accessToken: 'pk.eyJ1Ijoic3RlZXJkaWdpdGFsIiwiYSI6ImNrMm9sM3FjMjA1aGozYnRkMnBxbjdseTMifQ.Z5axBJPA-6kKYhELu1ZhPQ'
      }).addTo(map);
      mapRefs['map-' + year.yr + '-' + iIndex] = map
      map.on('zoom', function (e) {
        mapChange(map)
      })
      map.on('dragend', function (e) {
        mapChange(map)
      })

      function mapChange (map) {
        let ll = map.getCenter()
        let zoom = map.getZoom()
        let peerMapYear = year.yr === 2019 ? '2020' : '2019'
        mapRefs['map-' + peerMapYear + '-' + iIndex].setView(ll, zoom)
      }
      let t = popularStations[providerIdUnderscore].results
        .filter(x => x.yr === year.yr)
        .slice(0,100)
        .forEach(x => {
          let radialFactor = 500
          if (maxCount < 50000) {
            radialFactor = radialFactor * 2
          } else if (maxCount < 100000) {
            radialFactor = radialFactor * 1.5
          }
          let station = stationLocations[providerIdDash][x.start_station_id] || stationLocations[providerIdDash]["bcycle_lametro_" + x.start_station_id]
          let radius =  (x.station_count/maxCount) * radialFactor
          if (station) {
            L.circle([ Number(station.lat), Number(station.lon) ], {
              color: year.color,
              fillColor: year.color,
              fillOpacity: 0.5,
              radius: radius > 2 ? radius : 3
            })
            .bindTooltip(Number(x.station_count).toLocaleString() + " trips (" + station.name + ")", {
              sticky: true // If true, the tooltip will follow the mouse instead of being fixed at the feature center.
            })
            .addTo(map);
          }
        })
    })
  })

});

</script>
<section>
  <div class="section-body">
    <h2 class="ioreveal animate__animated" data-anicss="animate__fadeInDown" style="margin: 0; padding-top: 22px">
      <span class="material-icons">{mdIcon}</span>
      {title}
    </h2>
    <h4>{subtitle}</h4>

      {#each Object.keys(providersDash) as provider, i}
    <div class="row" style="padding-top: 30px">
        <div
          style="position: relative"
          class="col-xs-12 col-sm-12 col-md-8 col-lg-8 col-xl-8">
          <div class="maps-pair {mapFullscreen === i ? 'map-fullscreen' : ''}">
            <div class="close-fullscreen">
              <Icon class="material-icons" on:click="{() => closeFullscreen()}">close</Icon>
            </div>
            <div class="map-container">
              <div class="title-year title-year-2019">2019</div>
              <div class="map-2019" id="map-2019-{i}"></div>
            </div>
            <div class="map-container" styleNA="margin-top: 5px">
              <div class="title-year title-year-2020">2020</div>
              <div class="map-2020" id="map-2020-{i}"></div>
            </div>
          </div>
        </div>
        <div
          class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4"
          style="background-color: { i % 2 ? 'rgba(255,255,255,0.2)' : 'rgba(255,255,255,0.1)' };position: relative;">
          <div class="img-provider">
            <img
              src="{providersDash[provider].logo}"
              alt="{providersDash[provider].name}"
              style="height: { providersDash[provider].logoHeight }">
          </div>
          <div class="text-container">
            <div class="title-provider">
              {providersDash[provider].name}, {providersDash[provider].city}
              <div class="fullscreen-link" on:click={() => goFullscreen(i)}>
                <Icon class="material-icons">fullscreen</Icon>
              </div>
            </div>
            <div class="info-text">
             {popupInfo[provider.split("-").join("_")].info}
             </div>
          </div>
        </div>
  </div>
      {/each}
  </div>
</section>

<style>
/* div[class^="col-"] {
    outline: dashed;
} */
section {
  height: inherit;
}

h4 {
  margin-top: 10px;
}
.row {
  /* margin-top: 12px; */
  font-size: 1.2rem;
  padding: 0;
}
.row:nth-child(odd) {
  /* background-color: rgba(0,0,0,0.2); */
}
.section-body {
  /* max-width: 960px;
  padding: 30px;
  margin: auto; */
  padding-top: 0 !important;
  /* margin-left: 200px; */
  /* text-align: left; */
}

.map-container {
  position: relative;
}
.map-2019, .map-2020 {
  /* height: calc(50vh - 2px);
  width: calc(50vw - 2px); */
  width: 100%;
  height: 230px;
  margin: 0;
  /* margin-top: 0; */
}
.map-title {
  position: absolute;
  /* width: calc(50vw - 8px); */
  /* margin: 2px; */
  /* top: 2px;
  left: 2px;
  right: -2px; */
  z-index: 999;
  color: #fff;
  background-color: rgba(0,0,0,0.5);
  padding: 2px 5px;
  font-weight: bold;
}
.map-table {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 999;
  color: #fff;
  font-size: 12px;
  background-color: rgba(0,0,0,0.5);
  padding: 2px 5px;
  font-weight: bold;
}
.map-2019 {
  background-color: #ddd;
}
.map-2020 {
  background-color: #bbb;
}

.title-year {
  display: inline-block;
  position: absolute;
  left: 0;
  z-index: 999;
  color: #fff;
  background-color: rgba(0,0,0,0.5);
  padding: 2px 5px;
  font-weight: bold;
}
.title-year-2019 {
  color: #18c7de;
}
.title-year-2020 {
  color: #e5ff00;
}

.title-provider {
  margin-top: 20px;
  display: block;
  /* margin-top:30px;
  margin-bottom:-40px; */
  font-weight: bold;
}

.img-provider {
  position: absolute;
  bottom: 5px;
  left: 5px;
  /* background-color: rgba(255,255,255, 0.1); */
}
.text-container {
  text-align: left;
  position: relative;
}
.info-text {
  font-size: 1rem;
  margin-top: 20px;
  margin-bottom: 20px;
  padding-bottom: 20px;
  line-height: 150%;
}
@media (max-width: 768px) {
  .info-text {
    margin-bottom: 35px;
    padding-bottom: 35px;
  }
}
.fullscreen-link {
  cursor: pointer;
  float: right;
}
.map-fullscreen {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 9999;
}
.map-fullscreen .close-fullscreen {
  display: block;
}
.close-fullscreen {
  display: none;
  cursor: pointer;
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 9999;
}
.map-fullscreen .map-2019, .map-fullscreen .map-2020 {
  height: 50vh;
}
</style>